import { post } from "app/utils/axios/kheti"

interface ActionResponse {
  id: number
  latest_status: string
}
interface RejectPayload {
  reason_config_id: number | null
  reason: string
}

const validateRequest = async (
  action: "approve" | "reject",
  ids: number[],
  role_type?: string,
  reasonPayload?: RejectPayload
) => {
  const url = `/approvals/v1/action/${action}${role_type ? `?role_type=${role_type}` : ''}`

  const body: any = {
    change_request_ids: ids,
  }
  if (action === "reject" && reasonPayload) {
    body.reason_config_id = reasonPayload.reason_config_id
    body.reason = reasonPayload.reason
  }

  return await post<ActionResponse[]>(url, body)
}

export default validateRequest